import React from "react";

const LoadingBars = () => {
  return (
    <>
      <div
        className="p-4 mx-auto bg-slate-300 mt-2 h-12 animate-pulse"
        style={{ width: "99%" }}
      ></div>
      <div
        className="p-4 mx-auto bg-slate-300 mt-2 h-12 animate-pulse"
        style={{ width: "99%" }}
      ></div>
      <div
        className="p-4 mx-auto bg-slate-300 mt-2 h-12 animate-pulse"
        style={{ width: "99%" }}
      ></div>
    </>
  );
};

export default LoadingBars;
